var prefix = "_vux_cache_"

export function lsSet(key, value) {
	// console.log(`${key} = ${JSON.stringify(value)}`)
	localStorage.setItem(prefix + key, JSON.stringify(value))
}

export function lsGet(key, fallBack = null) {
	var s = localStorage.getItem(prefix + key)
	
	return s ? JSON.parse(s) : fallBack
}